import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, Route } from '@angular/router';

import { BaseGuard } from './base.guard';
import { AccountService } from '../../account/account.service';
import { UserService } from '../user.service';

declare const isEmpty: any;

@Injectable()
export class LoginGuard extends BaseGuard {
    constructor(protected router: Router, protected accountService: AccountService, protected userService: UserService) { super(router, accountService, userService); }

    canActivate(routeAc: ActivatedRouteSnapshot) {
        var token = routeAc.queryParams.token;
        var user_id = routeAc.queryParams.user_id;

        if (isEmpty(token) && isEmpty(user_id)) {
            let user = this.userService.user();

            // Se não tiver usuário logado, retorna que pode acessar a tela de login
            if (!user || isEmpty(user.homePage))
                return true;

            // Se o usuário já estiver logado, retorna para a home page dele
            this.navegarHomePage();
        }
    }
}
